import { TextButton } from "@SeemplicityDev/shared";
import React from "react";
import "./PageFormButtons.scss";
import { backButtonName, nextButtonName } from "../../FormWizardButtons";
import useFormWizard from "../../FormWizardProvider";

type PageFormButtonsProps = {
  "data-testid"?: string;
  nextButtonDisabled?: boolean;
};

const PageFormButtons: React.FC<PageFormButtonsProps> = ({
  "data-testid": dataTestId,
  nextButtonDisabled,
}) => {
  const {
    isFirstStep,
    isFormSubmitting,
    handleCancel,
    submitLabel,
    isLastStep,
    analyticsStepId,
  } = useFormWizard();

  return (
    <div className="page-form-buttons">
      <TextButton
        data-testid={`${dataTestId}-cancel-button`}
        type="button"
        label={"Cancel"}
        size={"large"}
        onClick={() => handleCancel()}
        data-analytics-event="user_click"
        data-analytics-props={`{"name": "cancel_btn", "step": "${analyticsStepId}"}`}
      />
      <div>
        <TextButton
          data-testid={`${dataTestId}-back-button`}
          className="page-form-buttons-back-button"
          type="submit"
          size={"large"}
          label={"Back"}
          disabled={isFirstStep}
          name={backButtonName}
          data-analytics-event="user_click"
          data-analytics-props={`{"name": "back_btn", "step": "${analyticsStepId}"}`}
        />
        <TextButton
          data-testid={`${dataTestId}-next-button`}
          type="submit"
          size={"large"}
          label={isLastStep ? submitLabel : "Next Step"}
          buttonStyle={"primary"}
          name={nextButtonName}
          disabled={nextButtonDisabled || isFormSubmitting}
          isSubmitting={isFormSubmitting}
          rightIcon={isFormSubmitting ? "seem-icon-spinner spinner" : ""}
          data-analytics-event="user_click"
          data-analytics-props={`{"name": "${isLastStep ? "create_btn" : "next_step_btn"}", "step": "${analyticsStepId}"}`}
        />
      </div>
    </div>
  );
};

export default PageFormButtons;
